import { render, staticRenderFns } from "./WhatsappPlusPlanCard.vue?vue&type=template&id=f9115930&scoped=true"
import script from "./WhatsappPlusPlanCard.vue?vue&type=script&lang=js"
export * from "./WhatsappPlusPlanCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9115930",
  null
  
)

export default component.exports